import React from "react";
import "../../App.css";
import SideBar from "../layout/sidebar/Sidebar";
import DashboardNavBar from "../layout/DashboardNavBar";
import New from "./NewProfile";

const ViewProfileCall = ({ match }) => {
  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <New id={match.params.id}/>
    </div>
  );
}

export default ViewProfileCall;